import { render, staticRenderFns } from "./ListingItem.vue?vue&type=template&id=c5545b46"
import script from "./ListingItem.vue?vue&type=script&lang=js"
export * from "./ListingItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports